import Card from "@mui/material/Card";
import { ComponentProps } from "../types";
import DashboardComponent from "./DashboardComponent";
import { CardActions, CardContent, CardHeader, Divider } from "@mui/material";
import ExecutionTypeContext, { Mode } from "../ExecutionTypeContext";
import { CSSProperties, useContext, useMemo } from "react";
import DashboardPageContext from "../DashboardPageContext";

function Component({ component }: ComponentProps) {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { context, params, updateContext } = useContext(DashboardPageContext);
	const exeMode = useContext(ExecutionTypeContext);
	const style = useMemo(() => {
		const style = {} as CSSProperties;
		if (exeMode?.mode === Mode.DESIGN && component.id === exeMode?.activeComponent?.id) style.border = "1px dashed red";
		if (component.properties["width"]) style.width = component.properties["width"];
		if (component.properties["height"]) style.height = component.properties["height"];
		if (component.properties["minHeight"]) style.minHeight = component.properties["minHeight"];
		if (component.properties["maxHeight"]) style.maxHeight = component.properties["maxHeight"];
		if (component.properties["flex"]) style.flex = component.properties["flex"];
		return style;
	}, [component, exeMode]);
	const cardActions = useMemo(() => {
		return component.childern.filter((c) => c.type === "CardActions")[0];
	}, [component]);
	const cardArgs = useMemo(() => {
		const args = {} as { [key: string]: unknown };
		return args;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [component, context]);
	const locatorArgs = useMemo(() => {
		const args = {} as { [key: string]: unknown };
		if (exeMode?.mode === Mode.DESIGN && exeMode.locatorActivated === true) {
			args["onClick"] = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
				if (exeMode.updateActiveComponent) exeMode.updateActiveComponent(component);
				event.stopPropagation();
			};
		}
		return args;
	}, [component, exeMode]);
	return (
		<Card style={style} sx={{ display: "flex", flexDirection: "column" }} {...cardArgs} {...locatorArgs}>
			{component.properties && component.properties["title"] && (
				<>
					<CardHeader title={component.properties["title"]} subheader={component.properties["subHeader"]}></CardHeader>
					<Divider />
				</>
			)}
			<CardContent sx={{ flex: 1, display: component.properties["flexBox"] === "True" ? "flex" : "initial" }}>{component.childern && component.childern.filter((c) => c.type !== "CardActions").map((c, i) => <DashboardComponent key={i} component={c} />)}</CardContent>
			{cardActions && (
				<>
					<Divider />
					<CardActions sx={{ display: "flex", flexDirection: "row-reverse" }}>
						<DashboardComponent component={cardActions} />
					</CardActions>
				</>
			)}
		</Card>
	);
}

export default Component;
